import { render, staticRenderFns } from "./PlanTable.vue?vue&type=template&id=6423e0bf&"
import script from "./PlanTable.vue?vue&type=script&lang=js&"
export * from "./PlanTable.vue?vue&type=script&lang=js&"
import style0 from "./PlanTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports